import {
    SEARCH_FAQ_REQUEST,
    SEARCH_FAQ_SUCCESS,
    SEARCH_FAQ_FAILURE,
} from 'api/index';
import {
    SET_FAQ_QUERY,
    CLEAR_FAQ_QUERY,
} from 'constants/ActionTypes';

const initialSettings = { query: '', results: [], searching: false, total: 0 };

const faq = (state = initialSettings, action) => {
    switch (action.type) {
        case CLEAR_FAQ_QUERY:
            return {
                ...state,
                query: '',
                results: [],
                total: 0,
            };

        case SET_FAQ_QUERY:
            return {
                ...state,
                query: action.payload.query,
            };

        case SEARCH_FAQ_REQUEST:
            return {
                ...state,
                searching: true,
            };

        case SEARCH_FAQ_SUCCESS:
            return {
                ...state,
                searching: false,
                results: action.payload.results,
                total: action.payload.total,
            };

        default:
            return state;
    }
};

export default faq;